
import React from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import { MAP } from 'react-google-maps/lib/constants';
import { setConnection } from "../../../store/actions/connection";
import { setMarker } from "../../../store/actions/marker";
import { connect } from "react-redux";
import { MAP_STYLES } from "../../../data/map-style";
import { applyMapHeight } from "./util";
import { mobileMatchMedia } from "../../../util";
import blackImage from "../../../semantic/dist/themes/fibrestream/assets/images/oval_black.png";
import redImage from "../../../semantic/dist/themes/fibrestream/assets/images/oval_prime.png";
import lightImage from "../../../semantic/dist/themes/fibrestream/assets/images/oval_light.png";
import ReactDOM from "react-dom";

class MapWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMarker: null,
      defaultCenter: null,
      defaultZoom: 11
    };
    this.mapRef = React.createRef();
    this.cityWiseCenter = {
      'Ottawa': { lat: 45.421532, lng: -75.697189 },
      'British Columbia': { lat: 49.260222, lng: -123.116276 },
      'Toronto': { lat: 43.700874769860846, lng: -79.38251335449218 }
    };

    this.goToSignup = this.goToSignup.bind(this);
    this.resetMarker = this.resetMarker.bind(this);
    this.closeMobileInfoWindow = this.closeMobileInfoWindow.bind(this);
    this.onInfoWindowDomReady = this.onInfoWindowDomReady.bind(this);
    this.setDefaultCenter = this.setDefaultCenter.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
  }


  onWindowResize() {
    console.log("here");

    const map = this.mapRef.current.context[MAP];
    const bounds = this.mapRef.current.getBounds();
    window.google.maps.event.trigger(this.mapRef.current && this.mapRef.current.context[MAP], 'resize');
    if (bounds) {
      map.fitBounds(bounds);
      map.panToBounds(bounds)
    }

    setTimeout(() => {
      map.setZoom(this.state.defaultZoom);
    }, 100);
  }

  componentDidMount() {
    this.registerEventListener();
    if (mobileMatchMedia()) {
      applyMapHeight();
    }

    this.setDefaultCenter(this.props.geoCity);
    window.addEventListener('resize', this.onWindowResize);
  }


  componentDidUpdate(prevProps) {
    if (prevProps.activeCity !== this.props.activeCity) {
      this.setDefaultCenter(this.props.activeCity);
    }
  }

  registerEventListener() {
    window.addEventListener('resize', () => {
      if (mobileMatchMedia()) {
        applyMapHeight();
      } else {
        this.closeMobileInfoWindow();
      }
    });
  }

  onMarkerClick(marker) {

    this.setState({
      activeMarker: marker
    });
    this.props.setMarker(this.getBlackDotSelectedMarkers(marker));
    if (mobileMatchMedia()) {
      const infoWindow = document.querySelector(".info-window");
      infoWindow.style.visibility = "visible";
      ReactDOM.render(
        <InfoWindowContent
          marker={marker}
          closeMobileInfoWindow={this.closeMobileInfoWindow}
          goToSignup={this.goToSignup}
        />,
        infoWindow
      );
    }
  }

  getBlackDotSelectedMarkers(props) {
    return this.props.markers.map(marker => {
      marker.icon = this.getImage(marker.result_type);

      if (marker.location === props.location) {
        marker.icon = blackImage;
      }
      return marker;
    });
  }

  getMarkers() {
    return this.props.markers.map(marker => {
      marker.icon = this.getImage(marker.result_type);
      return marker;
    });
  }
  closeMobileInfoWindow() {
    const infoWindow = document.querySelector(".info-window");
    if (infoWindow) {
      infoWindow.style.visibility = "hidden";
      this.resetMarker();
    }
  }

  goToSignup(connection) {
    delete connection.place_id;
    this.props.setConnection(connection);

    setTimeout(() => {
      if (connection.hasOwnProperty("promo")) {
        this.props.history.push(`/promotion/${connection.promo}`);
      }
      else {
        this.props.history.push('/check');
      }
    })
  }

  resetMarker() {
    this.setState({
      activeMarker: null
    });
    this.props.setMarker(this.getMarkers());
  }

  setDefaultCenter(city) {
    const defaultCenter = this.cityWiseCenter[city] !== undefined ? this.cityWiseCenter[city] : this.cityWiseCenter['Toronto'];
    this.setState({
      defaultCenter: defaultCenter
    });
  }

  getImage(type) {
    if (type === 1) {
      return redImage;
    } else if (type === 2) {
      return lightImage;
    }
    return blackImage;
  }

  componentWillUnmount() {
    this.props.setMarker(this.getMarkers());
  }

  onInfoWindowDomReady() {
    const iwOuter = document.querySelector(".gm-style-iw");
    if (iwOuter) {
      //  const firstChild = iwOuter.parentElement.firstChild;
      // firstChild.style.display = "none";
      //  iwOuter.nextSibling.style.display = "none";
    }
  }
  render() {
    const { markers } = this.props;
    const { activeMarker, defaultCenter, defaultZoom } = this.state;

    if (null === defaultCenter) {
      return null;
    }

    return (
      <GoogleMap
        defaultZoom={defaultZoom}
        center={defaultCenter}
        defaultOptions={{ styles: MAP_STYLES }}
        onClick={this.resetMarker}
        ref={this.mapRef}
      >
        {markers.map(marker => (
          <Marker
            key={marker.key}
            position={{ lat: marker.lat, lng: marker.lon }}
            icon={{ url: marker.icon, size: { width: 16, height: 16 } }}
            onClick={this.onMarkerClick.bind(this, marker)}

          >
            {activeMarker && activeMarker.location === marker.location && (
              <InfoWindow onDomReady={this.onInfoWindowDomReady}>
                <div id="iwc">
                  <InfoWindowContent
                    marker={marker}
                    closeMobileInfoWindow={this.closeMobileInfoWindow}
                    goToSignup={this.goToSignup}
                  />
                </div>
              </InfoWindow>
            )}
          </Marker>
        ))}
      </GoogleMap>
    );
  }
}

const InfoWindowContent = props => (
  <div className="info_content">
    <a className="close-btn" onClick={props.closeMobileInfoWindow}>
      &times;
    </a>
    <h4>{props.marker.location}</h4>
    <p className="place-text">{props.marker.city}</p>
    <div className="ui grid centered dot-left mx-0">
      {props.marker.result_type === 1 ? (
        props.marker.bf_on_net === 1 ?
        (<p className="dot bf">Beanfield Fibre</p>) :
        (<p className="dot text-prime">FibreReady</p>)
      ) : (
          <p className="dot grey"> Coming Soon </p>
        )}
    </div>
    {props.marker.result_type === 1 && (
      <button
        onClick={() => props.goToSignup(props.marker.connection)}
        className="ui button prime medium mr-0"
      >
        Sign Up
      </button>
    )}
    {(props.marker.result_type === 2 ||
      props.marker.result_type === 3 ||
      props.marker.result_type === 4) && (
        <button
          onClick={() => props.goToSignup(props.marker.connection)}
          className="ui button black btn--notified medium mr-0"
        >
          Get Notified
        </button>
      )}
  </div>
);

const mapStateToProps = state => {
  return {
    geoCity: state.app.geoCity
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setMarker: markers => dispatch(setMarker(markers)),
    setConnection: data => dispatch(setConnection(data)),
  };
};

MapWrapper = withScriptjs(withGoogleMap(MapWrapper));
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MapWrapper);



// WEBPACK FOOTER //
// ./src/components/home/map/MapWrapper.js